import React from 'react';
import {
    MealPreferencesSettings,
    NutritionTabNavigationWithOrderMeal,
    NutritionTabNavigationWithoutOrderMeal,
} from 'fitbeat.react-native-components/Nutrition/components';
import { GridLayoutWithRightContent } from './Layouts/GridLayoutWithRightContent';
import { createAppContainer, createSwitchNavigator } from 'react-navigation';

const NutritionNavigation=createSwitchNavigator({
    NutritionTabs: NutritionTabNavigationWithoutOrderMeal,
    NutritionTabsOrderMeals: NutritionTabNavigationWithOrderMeal,
    NutritionOnBoarding: MealPreferencesSettings,
});
const Nutrition = createAppContainer(NutritionNavigation);
export const NutritionScreenContainer = (props) => (
    <GridLayoutWithRightContent {...props}>
        <Nutrition />
    </GridLayoutWithRightContent>
);
